import { render, staticRenderFns } from "./MatchRow.vue?vue&type=template&id=d0feb444&lang=pug"
import script from "./MatchRow.vue?vue&type=script&lang=js"
export * from "./MatchRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports